<template>
    <div class="wrap" :style="{backgroundImage :`url(${moduleData.image})`, height, backgroundColor: moduleData.bgcolor || '#fff'}">
        <h2 :class="{whiteColor:keywd === 'milestone'}">{{moduleData.title}}</h2>
        <p class='subtitle' v-if="moduleData.subTitle" :style="{color: `${moduleData.color}`}">{{moduleData.subTitle}}</p>
        <p class='desc' v-if="moduleData.desc" v-html="moduleData.desc"></p>
        <slot></slot>
    </div>
</template>
<script>
export default {
    props:{
        keywd:{
          type: String,
          default:''
        },
        moduleData: {
          type: Object,
          default: () => {}
        },
        height: {
          type: String,
          default: ''
        }  
    }
}
</script>
<style lang="scss" scoped>
.wrap {
    @include Flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background-size: cover!important;
    // background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 50%;
    // background-color: #fff;
    
    h2 {
      padding-top: 72px;
      padding-bottom: 16px;
        font-size: 30px;
        line-height: 1;
        // line-height: 42px;
        font-weight: bold;
        color: #010101;
        &.whiteColor {
            color: #fff;
        }
        // &:before {
        //     content: "";
        //     width: 6px;
        //     height: 6px;
        //     border-radius: 6px;
        //     background-color:  #FF397E;
        //     position: absolute;
        //     top:50%;
        //     margin-top: -3px;
        //     left: -28px;
        // }
        // &:after {
        //     content: "";
        //     width: 6px;
        //     height: 6px;
        //     border-radius: 6px;
        //     background-color:  #FF397E;
        //     position: absolute;
        //     top:50%;
        //     margin-top: -3px;
        //     right: -28px;
        // }
        // &+* {
        //     margin-top: -160px;
        //     padding-top: 160px;
        // }
    }

    .subtitle{
      font-size: 14px;
      color: #505050;
    }
    .desc {
      padding-top: 53px;
      font-size: 39px;
      line-height: 1.2;
      // line-height: 28px;
      font-weight: bold;
      color: #fff;
      text-align: center;
    }
}
</style>


